// Home page (route "/"): start page, department tabs and their widgets.
export default {
  en: {
    home: {
      common: {
        open: 'Open',
        viewAll: 'View all',
        viewAllCount: 'View all {count}',
        team: 'Team',
        teamHint: 'No buyer assignment – team data',
        days: '{n} day | {n} days',
      },
      tabs: {
        customerSupport: 'Customer Support',
        purchase: 'Purchase Department',
        productManagement: 'Product Management',
      },
      scope: {
        mine: 'Mine',
        team: 'Team',
        fallback: 'No JTL user assigned',
      },
      welcome: {
        user: 'User',
        morning: 'Good morning',
        day: 'Good afternoon',
        evening: 'Good evening',
        hours: 'Hours this month',
        openTasks: 'Open tasks',
        holidays: 'Upcoming holidays',
      },
      customerSupport: {
        loadError: 'Customer Support data could not be loaded',
        offers: {
          title: 'Open offers',
          subtitle: '{amount} net',
          hint: '{count} older than {days} days – call',
        },
        delivery: {
          title: 'Delivery Date Dashboard',
          subtitle: 'Orders with a critical delivery date',
          hint: '{count} delivery date unconfirmed | {count} delivery dates unconfirmed',
        },
        leads: {
          title: 'Sales Board',
          subtitle: 'Interesting new customers (open suggestions)',
          hint: '{count} with high potential, not yet contacted',
        },
      },
      purchase: {
        loadError: 'Purchase data could not be loaded',
        delayed: {
          title: 'Delayed orders',
          subtitle: 'Late supplier orders',
          hint: '{count} order unconfirmed | {count} orders unconfirmed',
        },
        open: {
          title: 'Open supplier orders',
          subtitle: '{amount} gross',
          hint: '{count} overdue – delivery date exceeded',
        },
        approvals: {
          title: 'Purchase approvals',
          subtitle: 'Open approval requests',
          hint: '{count} needs Managing-Director approval | {count} need Managing-Director approval',
        },
      },
      productManagement: {
        loadError: 'Product data could not be loaded',
        review: {
          title: 'Product data review',
          subtitle: 'Rows to review',
          hint: '{count} approved this week',
        },
        updated: {
          title: 'Update status',
          subtitle: 'Items waiting for shop update',
          hint: '{count} being deactivated/deleted',
        },
        outdated: {
          title: 'Outdated products',
          subtitle: 'Items no longer found at the supplier',
        },
      },
      pageLinks: {
        title: 'More areas',
      },
      search: {
        title: 'Item search shop & suppliers',
        placeholder: 'Item number, name or manufacturer…',
        submit: 'Search',
        ownProducts: 'Own products',
        scraped: 'Suppliers/competitors (scraped)',
        uploaded: 'Suppliers/competitors (uploaded)',
        notInRange: 'Not in range',
        drive: 'Google Drive',
      },
      offerFollowUp: {
        title: 'Follow up on offers',
        empty: 'No open offers',
        toList: 'Go to offer list',
        actions: {
          call: 'CALL',
          follow_up: 'FOLLOW UP',
          open: 'OPEN',
        },
      },
      criticalDelivery: {
        title: 'Critical delivery dates',
        empty: 'No critical delivery dates',
        reasons: {
          supplier_late: 'Supplier late',
          partial: 'Partial delivery',
          unconfirmed: 'Unconfirmed',
        },
      },
      salesLeads: {
        title: 'Sales Board – interesting customers',
        empty: 'No open suggestions',
        toBoard: 'Go to Sales Board',
        firstOrder: 'First order {amount} net',
        rules: {
          large_first_order: 'Large first order',
          trade_keyword: 'Refrigeration/air conditioning trade',
        },
        potential: {
          high: 'HIGH',
          medium: 'MEDIUM',
        },
      },
      greyhound: {
        title: 'Greyhound – open tickets',
        oldest: 'Oldest ticket: {age} ({date})',
        fallback: 'No Greyhound user assigned – team data',
        unassigned: 'Unassigned',
        others: 'Others',
        empty: 'No open tickets',
        toStats: 'Go to email statistics',
      },
      delayedOrders: {
        title: 'Delayed orders – chase supplier',
        reference: 'Reference: {order}',
        deliveryDate: 'Delivery date {date}',
        empty: 'No delayed orders',
        overdue: '{n} day overdue | {n} days overdue',
        dueToday: 'due today',
        dueIn: 'due in {n} day | due in {n} days',
      },
      recommendations: {
        title: 'Purchase recommendations – order today',
        empty: 'No suggestions',
        total: '{count} suggestion in total | {count} suggestions in total',
        inquire: 'Inquire',
        inquireTitle: 'Long lead time – ask supplier about availability',
        daysShort: '{days} d',
        fields: {
          article: 'Item',
          supplier: 'Supplier',
          stock: 'Stock',
          reach: 'Days of cover',
          qty: 'Qty',
          abc: 'ABC',
        },
      },
      negotiation: {
        title: 'Negotiation opportunities',
        noSupplier: 'No default supplier',
        empty: 'No negotiation opportunities',
        reason: '{amount} purchases/12 mo (tier {tier})',
        stability: {
          INCREASING: 'sales rising',
          STABLE: 'sales stable',
          NEW: 'new',
          DECLINING: 'sales declining',
        },
      },
      pipeline: {
        title: 'Product data pipeline',
        pending: 'to review',
        approvedWeek: 'approved this week',
        newArticles: 'new articles approved (month)',
        aRate: 'A required-attribute rate',
        aRateTitle: 'Categories weighted by number of A items',
      },
      marketplace: {
        title: 'Marketplace readiness – missing data',
        complete: 'master data complete',
        turnover: 'Turnover last 12 months',
        empty: 'No items in "List After Content Fix"',
        gaps: {
          EAN: 'EAN',
          MPN: 'MPN',
          Bilder: 'Images',
          Gewicht: 'Weight',
        },
      },
      movers: {
        title: 'Fast / slow movers',
        fast: 'FASTMOVER',
        drop: 'DECLINE',
        orders: '{num} order | {num} orders',
        drops: '{num} pcs vs. last year',
        empty: 'No fast or slow movers',
        notSold: 'Not sold for 6 months',
        withStock: 'with stock',
        items: '{num} item | {num} items',
        toMovers: 'Fast/slow movers',
        toNotSold: 'Not sold products',
      },
      categories: {
        title: 'Category development – YTD vs. previous year',
        new: 'new',
        empty: 'No category data',
      },
      kpi: {
        title: 'Development – last 12 weeks',
        subtitle: 'Compared to the 12 weeks before',
        since: 'History since {date}',
        noHistory: 'No history yet',
        empty: 'No KPIs available',
        loadError: 'KPIs could not be loaded',
        daysUnit: 'days',
        labels: {
          delivery_time: 'Avg. delivery time',
          offer_conversion: 'Conversion offer → order',
          revenue: 'Revenue',
          order_intake: 'Order intake',
          reaction_time: 'Avg. response time',
          supplier_on_time: 'Supplier on-time rate',
          replenishment_time: 'Avg. replenishment time',
          purchase_volume: 'Purchase volume',
          a_days_of_cover: 'Days of cover A products',
          data_quality: 'Data quality',
          active_articles: 'Active items',
          a_marketplace_ready: 'Marketplace-ready A items',
          revenue_per_active_article: 'Revenue per active item',
        },
      },
      quickLinks: {
        title: 'Quick Links',
        subtitle: 'Access your resources',
        info: 'The Quick Links section contains a collection of helpful resources and tools to assist with your work. Access key websites and applications quickly and easily.',
        howToJtl: 'How to JTL',
        faq: 'FAQ catalog',
        classroom: 'Google Classroom',
        drive: 'Google Drive',
        bookCall: 'Book a call',
        googleReviews: 'Google reviews',
        customerReviews: 'Customer reviews',
        phone: 'Phone dashboard',
      },
      holidays: {
        title: 'German Holidays',
        subtitle: 'Upcoming public holidays',
        info: 'List of upcoming German public holidays, helping you plan your work accordingly.',
        empty: 'No upcoming holidays',
      },
      calendar: {
        title: 'Team Calendar',
        subtitle: 'Track team events, vacations, and meetings',
        info: 'Google Calendar for all team events, including vacations, sick days, meetings, and more. Keep track of important dates and stay organized effortlessly.',
      },
      tasks: {
        title: 'Tasks',
        subtitle: 'Manage your to-do list',
        all: 'All tasks',
        info: "The to-do list shows all team tasks with their dates and assigned members. Click 'Add new task' to create a task in a form.",
        delete: 'Delete task',
        empty: 'No tasks yet. Create one to get started!',
        add: 'Add new task',
        confirmTitle: 'Are you sure?',
        confirmText: "You won't be able to revert this!",
        confirmButton: 'Yes, delete!',
        cancel: 'Cancel',
        deleted: 'Task has been deleted',
        form: {
          add: 'Add task',
          update: 'Update task',
          submit: 'Submit',
          close: 'Close',
          title: 'Title',
          description: 'Description',
          date: 'Date',
          assignedTo: 'Assigned to',
          updated: 'Task has been updated',
          created: 'Task has been created',
          error: 'Error!',
        },
      },
    },
  },
  de: {
    home: {
      common: {
        open: 'Öffnen',
        viewAll: 'Alle anzeigen',
        viewAllCount: 'Alle {count} anzeigen',
        team: 'Team',
        teamHint: 'Keine Zuordnung zu Einkäufern – Daten des Teams',
        days: '{n} Tag | {n} Tage',
      },
      tabs: {
        customerSupport: 'Kundenservice',
        purchase: 'Einkauf',
        productManagement: 'Produktmanagement',
      },
      scope: {
        mine: 'Eigene',
        team: 'Team',
        fallback: 'Kein JTL-Benutzer zugeordnet',
      },
      welcome: {
        user: 'Benutzer',
        morning: 'Guten Morgen',
        day: 'Guten Tag',
        evening: 'Guten Abend',
        hours: 'Stunden diesen Monat',
        openTasks: 'Offene Aufgaben',
        holidays: 'Kommende Feiertage',
      },
      customerSupport: {
        loadError: 'Kundenservice-Daten konnten nicht geladen werden',
        offers: {
          title: 'Offene Angebote',
          subtitle: '{amount} netto',
          hint: '{count} älter als {days} Tage – anrufen',
        },
        delivery: {
          title: 'Liefertermin-Dashboard',
          subtitle: 'Aufträge mit kritischem Termin',
          hint: '{count} Liefertermin unbestätigt | {count} Liefertermine unbestätigt',
        },
        leads: {
          title: 'Salesboard',
          subtitle: 'Interessante neue Kunden (offene Vorschläge)',
          hint: '{count} mit hohem Potenzial, noch nicht kontaktiert',
        },
      },
      purchase: {
        loadError: 'Einkaufsdaten konnten nicht geladen werden',
        delayed: {
          title: 'Verspätete Bestellungen',
          subtitle: 'Verspätete Lieferantenbestellungen',
          hint: '{count} Bestellung unbestätigt | {count} Bestellungen unbestätigt',
        },
        open: {
          title: 'Offene Lieferantenbestellungen',
          subtitle: '{amount} brutto',
          hint: '{count} überfällig – Liefertermin überschritten',
        },
        approvals: {
          title: 'Einkaufsfreigaben',
          subtitle: 'Offene Freigabeanfragen',
          hint: '{count} benötigt Freigabe durch die Geschäftsführung | {count} benötigen Freigabe durch die Geschäftsführung',
        },
      },
      productManagement: {
        loadError: 'Produktdaten konnten nicht geladen werden',
        review: {
          title: 'Produktdaten-Prüfung',
          subtitle: 'Zeilen zu prüfen',
          hint: '{count} diese Woche freigegeben',
        },
        updated: {
          title: 'Update-Status',
          subtitle: 'Artikel warten auf Shop-Update',
          hint: '{count} werden deaktiviert/gelöscht',
        },
        outdated: {
          title: 'Veraltete Artikel',
          subtitle: 'Artikel beim Lieferanten nicht mehr gefunden',
        },
      },
      pageLinks: {
        title: 'Weitere Bereiche',
      },
      search: {
        title: 'Artikelsuche Shop & Lieferanten',
        placeholder: 'Artikelnummer, Name oder Hersteller…',
        submit: 'Suchen',
        ownProducts: 'Eigene Produkte',
        scraped: 'Lieferanten/Wettbewerber (gescrapt)',
        uploaded: 'Lieferanten/Wettbewerber (hochgeladen)',
        notInRange: 'Nicht im Sortiment',
        drive: 'Google Drive',
      },
      offerFollowUp: {
        title: 'Angebote nachfassen',
        empty: 'Keine offenen Angebote',
        toList: 'Zur Angebotsliste',
        actions: {
          call: 'ANRUFEN',
          follow_up: 'NACHFASSEN',
          open: 'OFFEN',
        },
      },
      criticalDelivery: {
        title: 'Kritische Liefertermine',
        empty: 'Keine kritischen Liefertermine',
        reasons: {
          supplier_late: 'Lieferant verspätet',
          partial: 'Teillieferung',
          unconfirmed: 'Unbestätigt',
        },
      },
      salesLeads: {
        title: 'Salesboard – interessante Kunden',
        empty: 'Keine offenen Vorschläge',
        toBoard: 'Zum Salesboard',
        firstOrder: 'Erstauftrag {amount} netto',
        rules: {
          large_first_order: 'Großer Erstauftrag',
          trade_keyword: 'Kälte-/Klimabranche',
        },
        potential: {
          high: 'HOCH',
          medium: 'MITTEL',
        },
      },
      greyhound: {
        title: 'Greyhound – offene Tickets',
        oldest: 'Ältestes Ticket: {age} ({date})',
        fallback: 'Kein Greyhound-Benutzer zugeordnet – Teamdaten',
        unassigned: 'Nicht zugewiesen',
        others: 'Weitere',
        empty: 'Keine offenen Tickets',
        toStats: 'Zur E-Mail-Statistik',
      },
      delayedOrders: {
        title: 'Verspätete Bestellungen – Lieferant nachfassen',
        reference: 'Bezug: {order}',
        deliveryDate: 'Liefertermin {date}',
        empty: 'Keine verspäteten Bestellungen',
        overdue: '{n} Tag überfällig | {n} Tage überfällig',
        dueToday: 'heute fällig',
        dueIn: 'fällig in {n} Tag | fällig in {n} Tagen',
      },
      recommendations: {
        title: 'Einkaufsempfehlungen – heute bestellen',
        empty: 'Keine Vorschläge',
        total: '{count} Vorschlag gesamt | {count} Vorschläge gesamt',
        inquire: 'Anfragen',
        inquireTitle: 'Lange Lieferzeit – Verfügbarkeit beim Lieferanten anfragen',
        daysShort: '{days} T',
        fields: {
          article: 'Artikel',
          supplier: 'Lieferant',
          stock: 'Bestand',
          reach: 'Reichweite',
          qty: 'Menge',
          abc: 'ABC',
        },
      },
      negotiation: {
        title: 'Verhandlungspotenziale',
        noSupplier: 'Kein Standardlieferant',
        empty: 'Keine Verhandlungspotenziale',
        reason: '{amount} Einkauf/12 M (Tier {tier})',
        stability: {
          INCREASING: 'Absatz steigend',
          STABLE: 'Absatz stabil',
          NEW: 'neu',
          DECLINING: 'Absatz rückläufig',
        },
      },
      pipeline: {
        title: 'Produktdaten-Pipeline',
        pending: 'zu prüfen',
        approvedWeek: 'diese Woche freigegeben',
        newArticles: 'Neuanlagen freigegeben (Monat)',
        aRate: 'A-Pflichtattribut-Quote',
        aRateTitle: 'Kategorien gewichtet nach Anzahl A-Artikel',
      },
      marketplace: {
        title: 'Marketplace Readiness – fehlende Daten',
        complete: 'Stammdaten vollständig',
        turnover: 'Umsatz letzte 12 Monate',
        empty: 'Keine Artikel in „List After Content Fix“',
        gaps: {
          EAN: 'EAN',
          MPN: 'MPN',
          Bilder: 'Bilder',
          Gewicht: 'Gewicht',
        },
      },
      movers: {
        title: 'Fast-/Slowmover',
        fast: 'FASTMOVER',
        drop: 'RÜCKGANG',
        orders: '{num} Auftrag | {num} Aufträge',
        drops: '{num} Stk. ggü. Vorjahr',
        empty: 'Keine Fast- oder Slowmover',
        notSold: 'Nicht verkauft seit 6 Monaten',
        withStock: 'mit Lagerbestand',
        items: '{num} Artikel | {num} Artikel',
        toMovers: 'Fast-/Slowmover',
        toNotSold: 'Nicht verkaufte Artikel',
      },
      categories: {
        title: 'Kategorie-Entwicklung – YTD vs. Vorjahr',
        new: 'neu',
        empty: 'Keine Kategoriedaten',
      },
      kpi: {
        title: 'Entwicklung – letzte 12 Wochen',
        subtitle: 'Vergleich zu den 12 Wochen davor',
        since: 'Verlauf ab {date}',
        noHistory: 'Noch kein Verlauf',
        empty: 'Keine Kennzahlen verfügbar',
        loadError: 'Kennzahlen konnten nicht geladen werden',
        daysUnit: 'Tage',
        labels: {
          delivery_time: 'Ø Lieferzeit',
          offer_conversion: 'Konvertierung Angebot → Auftrag',
          revenue: 'Umsatz',
          order_intake: 'Auftragseingang',
          reaction_time: 'Ø Reaktionszeit',
          supplier_on_time: 'Termintreue Lieferanten',
          replenishment_time: 'Ø Wiederbeschaffungszeit',
          purchase_volume: 'Einkaufsvolumen',
          a_days_of_cover: 'Lagerreichweite A-Produkte',
          data_quality: 'Datenqualität',
          active_articles: 'Aktive Artikel',
          a_marketplace_ready: 'Marketplace-ready A-Artikel',
          revenue_per_active_article: 'Umsatz je aktivem Artikel',
        },
      },
      quickLinks: {
        title: 'Schnellzugriff',
        subtitle: 'Wichtige Links und Ressourcen',
        info: 'Der Schnellzugriff bündelt hilfreiche Webseiten und Tools für die tägliche Arbeit.',
        howToJtl: 'How to JTL',
        faq: 'Fragenkatalog',
        classroom: 'Google Classroom',
        drive: 'Google Drive',
        bookCall: 'Termin buchen',
        googleReviews: 'Google-Bewertungen',
        customerReviews: 'Kundenbewertungen',
        phone: 'Telefon-Dashboard',
      },
      holidays: {
        title: 'Feiertage in Deutschland',
        subtitle: 'Kommende gesetzliche Feiertage',
        info: 'Liste der kommenden gesetzlichen Feiertage in Deutschland – hilft bei der Planung.',
        empty: 'Keine kommenden Feiertage',
      },
      calendar: {
        title: 'Teamkalender',
        subtitle: 'Termine, Urlaub und Meetings im Team',
        info: 'Google Kalender für alle Teamtermine, z. B. Urlaub, Krankheitstage und Meetings. So behält jeder wichtige Termine im Blick.',
      },
      tasks: {
        title: 'Aufgaben',
        subtitle: 'To-do-Liste verwalten',
        all: 'Alle Aufgaben',
        info: 'Die To-do-Liste zeigt alle Teamaufgaben mit Datum und zugewiesenen Mitarbeitern. Über „Neue Aufgabe“ lässt sich per Formular eine Aufgabe anlegen.',
        delete: 'Aufgabe löschen',
        empty: 'Noch keine Aufgaben vorhanden.',
        add: 'Neue Aufgabe',
        confirmTitle: 'Aufgabe wirklich löschen?',
        confirmText: 'Dies kann nicht rückgängig gemacht werden.',
        confirmButton: 'Ja, löschen!',
        cancel: 'Abbrechen',
        deleted: 'Aufgabe wurde gelöscht',
        form: {
          add: 'Aufgabe hinzufügen',
          update: 'Aufgabe bearbeiten',
          submit: 'Speichern',
          close: 'Schließen',
          title: 'Titel',
          description: 'Beschreibung',
          date: 'Datum',
          assignedTo: 'Zugewiesen an',
          updated: 'Aufgabe wurde aktualisiert',
          created: 'Aufgabe wurde angelegt',
          error: 'Fehler!',
        },
      },
    },
  },
}
